import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-occupation-capture',
  templateUrl: './occupation-capture.component.html',
  styleUrls: ['./occupation-capture.component.scss']
})
export class OccupationCaptureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  savedAdd
  Occupation
  yearlyIncome
  

  list = [
    1
]
}
